import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import printerThermalMiddlwrare from "../printer/thermalprinter.middleware";


 
  export default applyMiddleware(thunk,printerThermalMiddlwrare)